module.exports = __webpack_public_path__ + "static/logo-062d524c437f9a9cab1295151c44136b.png";